import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {NzIconModule} from 'ng-zorro-antd/icon'
import {FormsModule} from '@angular/forms'
import {NzModule} from '../../nz.module'
import {UserGuideService} from './user.guide.service'
import {UserGuideComponent} from './user.guide.component'

@NgModule({
  declarations: [
    UserGuideComponent
  ],
  imports: [
    CommonModule,
    NzIconModule,
    FormsModule,
    NzModule
  ],
  exports: [
    UserGuideComponent
  ],
  providers: [
    UserGuideService
  ]
})

export class UserGuideModule {
  constructor() {}
}
